var _rect, _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOrgasmeatPlaceholder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 320",
    role: "img",
    "aria-label": "Visuel \\xE0 venir",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 320,
    fill: "#ffffeb"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#51182f",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 140,
    r: 56
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 140,
    r: 40,
    stroke: "#d0b0f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 92v43m-12-43v30q0 15 12 15t12-15V92m-12 45v59m172-104v104m0-104q-24 12-18 52h18"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 240,
    y: 246,
    fill: "#51182f",
    fontFamily: "Arial, sans-serif",
    fontSize: 18,
    textAnchor: "middle"
  }, "Visuel \xE0 venir")));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOrgasmeatPlaceholder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/OrgasmeatPlaceholder.24fcaee15893c94cadd2004a41f310ef.svg";